// extracted by mini-css-extract-plugin
export var chip = "_5j-9";
export var chipLabel = "_5j-a";
export var close = "_5j-7";
export var closeIcon = "_5j-8";
export var error = "_5j-6";
export var infoTooltip = "_5j-2";
export var innerContainer = "_5j-1";
export var input = "_5j-b";
export var medium = "_5j-5";
export var outerContainer = "_5j-0";
export var small = "_5j-4";
export var xSmall = "_5j-3";